import $ from 'jquery';
import { ENDERECO_API } from '../../config/constant';
import { decode as rawBase64Decode, encode as base64_encode } from 'base-64';
import { showDuplicateLoginAlert } from '../../components/Auth/DuplicateLoginAlert';

const normalizeGtveResponse = (value) => {
  if (typeof value !== 'string') {
    return value;
  }

  let normalizedValue = value.trim();

  if (normalizedValue.startsWith('"') && normalizedValue.endsWith('"')) {
    normalizedValue = JSON.parse(normalizedValue);
  }

  return normalizedValue;
};

const base64_decode = (value) => rawBase64Decode(normalizeGtveResponse(value));

const isHistoricoGtveAuthError = (xhr) => {
  const candidates = [xhr?.message, xhr?.responseText, xhr?.responseJSON];

  return candidates.some((value) => {
    if (value === 'erro_auth') {
      return true;
    }

    if (typeof value !== 'string') {
      return false;
    }

    let normalizedValue = value.trim();

    if (normalizedValue.startsWith('"') && normalizedValue.endsWith('"')) {
      normalizedValue = JSON.parse(normalizedValue);
    }

    try {
      normalizedValue = base64_decode(normalizedValue);
    } catch (err) {
      return normalizedValue === 'erro_auth';
    }

    return normalizedValue === 'erro_auth';
  });
};

const handleHistoricoGtveError = (xhr, reject, rejectMessage) => {
  if (isHistoricoGtveAuthError(xhr)) {
    showDuplicateLoginAlert();
  }

  reject([400, { message: rejectMessage }]);
};

const getSession = () => {
  const usersRt = sessionStorage.getItem('ddesp');
  return usersRt !== null ? JSON.parse(base64_decode(usersRt)) : null;
};

const ajaxHistoricoGtveEvent = ({
  type,
  ll,
  dd,
  tk,
  parseType = 'jsonBase64',
  rejectMessage = 'erro',
  extraData = {},
}) => new Promise(function (resolve, reject) {
  try {
    $.ajax({
      url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
      type,
      dataType: 'text',
      headers: {
        Authorization: 'Bearer ' + tk,
      },
      data: {
        pp: base64_encode('gtve'),
        ll: base64_encode(ll),
        dd: base64_encode(JSON.stringify(dd)),
        tk,
        ...extraData,
      },
      success: function (data) {
        if (parseType === 'jsonBase64') {
          resolve([200, JSON.parse(base64_decode(data))]);
          return;
        }

        if (parseType === 'base64') {
          resolve([200, base64_decode(data)]);
          return;
        }

        if (parseType === 'jsonOrBase64') {
          const decodedData = base64_decode(data);

          try {
            resolve([200, JSON.parse(decodedData)]);
          } catch (err) {
            resolve([200, decodedData]);
          }
          return;
        }

        resolve([200, data]);
      },
      error: function (xhr) {
        handleHistoricoGtveError(xhr, reject, rejectMessage);
      },
    });
  } catch (err) {
    reject([500, { message: err + ' Server Error' }]);
  }
});

const RestHistoricoGtvePost = (config) => {
  const Arr_ = JSON.parse(config.data);
  const caminho = Arr_.dest.trim();
  const storage = getSession();
  const emp = storage[0];
  const uid = storage[3];
  const token = storage[14];

  switch (caminho) {
    case 'pesqGtve':
      return ajaxHistoricoGtveEvent({
        type: 'Post',
        ll: 'pesqGtve',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
      });

    case 'getMarcadoresGtve':
      return ajaxHistoricoGtveEvent({
        type: 'Get',
        ll: 'getMarcadoresGtve',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify({}))],
        tk: token,
      });

    case 'setMarcadorGtve':
    case 'setMarcador':
      return ajaxHistoricoGtveEvent({
        type: 'Post',
        ll: 'setMarcador',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
      });

    case 'deleteMarcadoresGtve':
      return ajaxHistoricoGtveEvent({
        type: 'Post',
        ll: 'deleteMarcadores',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
      });

    case 'downloadGtve':
      return ajaxHistoricoGtveEvent({
        type: 'Post',
        ll: 'downloadLote',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
        parseType: 'base64',
        extraData: { tipo: 1 },
      });

    case 'updateAnotacao':
      return ajaxHistoricoGtveEvent({
        type: 'Post',
        ll: 'updateAnotacao',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
      });

    case 'printGtve':
      return ajaxHistoricoGtveEvent({
        type: 'Post',
        ll: 'printGtve',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
        parseType: 'jsonOrBase64',
        rejectMessage: 'erro ao gerar DAGTV-e',
      });

    case 'salvaNovoMarcadorGtve':
    case 'salvaNovoMarcador':
      return ajaxHistoricoGtveEvent({
        type: 'Post',
        ll: 'salvaNovoMarcadorGtve',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
      });

    default:
      return new Promise((resolve, reject) => reject([404, { message: 'Rota não encontrada' }]));
  }
};

const RestHistoricoGtveGet = (config) => {
  const caminho = config.dest.trim();
  const storage = getSession();
  const emp = storage[0];
  const uid = storage[3];
  const token = storage[14];

  switch (caminho) {
    case 'getMarcadores':
    case 'getMarcadoresGtve':
      return ajaxHistoricoGtveEvent({
        type: 'Get',
        ll: 'getMarcadores',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify({}))],
        tk: token,
      });

    case 'getConfigTableGtve':
      return ajaxHistoricoGtveEvent({
        type: 'Get',
        ll: 'getConfigTableGtve',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify({}))],
        tk: token,
      });

    default:
      return new Promise((resolve, reject) => reject([404, { message: 'Rota não encontrada' }]));
  }
};

export { RestHistoricoGtvePost, RestHistoricoGtveGet };
